import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: "app-tipo-unidad-formulario",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  dato: FormGroup;
  um;
  tamano = document.body.clientHeight;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""],
      nombre: ["", [Validators.required]],
      clave: ["", [Validators.required]],
      simbolo: [""],
      tipo_medida: ["M1", [Validators.required]]
    });
    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  seleccionarValorSelect2(valor, modelo) {
    setTimeout(() => {
      for (let i = 0, len = modelo.length; i < len; i++) {
        if (modelo[i].id == valor.value && modelo[i].id != "") {
          this.dato.controls.clave.patchValue(modelo[i].clave);
          this.dato.controls.nombre.patchValue(modelo[i].nombre);
          this.dato.controls.simbolo.patchValue(modelo[i].simbolo);
          break;
        }
      }
    }, 100);
  }
}
